module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div ng-if="!view" style="display:inline;">\n  <a class="gallery-viewer">\n    <small class="photos"><span ng-bind-html="::count"></span> <i class="fa fa-picture-o"></i></small>\n  </a>\n</div>\n\n<div ng-if="view==\'grid\'" class="grid-x">\n  <div ng-repeat="i in gallery" style="cursor:pointer;" photo-index="{{$index}}" id="{{$index}}" class="photo-thumb small-4 medium-3 large-3">\n    <div class="square-container">\n      <img ng-src="{{i.image}}?_=t">\n    </div>\n  </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./src/app/directives/templates/photo-gallery.html
// module id = 293
// module chunks = 0